import { tr } from '@/lib/i18n-core';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { VisitorLocation } from '@his/shared';
import { get, qs } from '@/lib/api';
import { DataTable, PageHeader, SearchFilterBar } from '@/components/ui/layout';

const MIN_SEARCH_LENGTH = 3;

export function VisitorLocatorPage() {
  const [term, setTerm] = useState('');

  const searching = term.length >= MIN_SEARCH_LENGTH;

  const results = useQuery({
    queryKey: ['visitor-locator', term],
    queryFn: () => get<VisitorLocation[]>(`/ipd/locator${qs({ q: term })}`),
    enabled: searching,
  });

  return (
    <>
      <PageHeader
        title={tr('ipd', 'find_a_patient')}
        description={tr('ipd', 'where_an_admitted_patient_is_for_visitors_ward')}
      />

      <SearchFilterBar
        search={{ value: term, onChange: setTerm, placeholder: tr('ipd', 'patient_name'), label: tr('ipd', 'patient_name'), autoFocus: true }}
      />

      {searching ? (
        <DataTable
          rows={results.data}
          loading={results.isLoading} refreshing={results.isFetching}
          error={results.error}
          rowKey={(row) => row.admissionId}
          empty={tr('ipd', 'no_admitted_patient_matches_that_name')}
          columns={[
            { header: tr('ipd', 'patient'), sort: (row) => row.patientName, cell: (row) => <span className="font-medium">{row.patientName}</span> },
            { header: tr('ipd', 'ward'), sort: (row) => row.ward, cell: (row) => row.ward },
            { header: tr('ipd', 'room'), sort: (row) => row.room, cell: (row) => row.room },
            { header: tr('ipd', 'bed'), sort: (row) => row.bed, cell: (row) => row.bed },
          ]}
        />
      ) : (
        <div className="rounded-lg border p-10 text-center text-sm text-muted-foreground">
          {tr('ipd', 'type_at_least')} {MIN_SEARCH_LENGTH} {tr('ipd', 'letters_of_the_patients_name')}
        </div>
      )}
    </>
  );
}
